import React, { useEffect, useState } from "react"
import axios from "../../../axios"
import api from "../../../api"
import Stack from '@mui/material/Stack'
import Grid from "@mui/material/Grid"
import BasicSelector from "../../../Components/BasicSelector"
export default function CatalogCourseSelect(props) {
    // Data states
    const [goals, setGoals] = useState([])
    const [courses, setCourses] = useState([])

    const config = {
        headers: {
            "x-auth-token": localStorage.getItem("user"),
        }
    }

    // Select data props
    const goalData = {
        title: "Goals",
        items: goals,
        selected: props.selectedGoal
    }

    const courseData = {
        title: "Courses",
        items: courses,
        selected: props.selectedCourse
    }

    // Select elements
    const goalSelector = (
        <Grid item>
            <BasicSelector data={goalData} sx={{ width: 200 }} handleSelection={handleGoalSelection} />
        </Grid>
    )


    const courseSelector = (
        <Grid item>
            <BasicSelector data={courseData} sx={{ width: 200 }} handleSelection={handleCourseSelection} />
        </Grid>
    )

    useEffect(() => {
      getGoalsForFilter();
    }, []);

    useEffect(() => {
      getCoursesForFilter(props.selectedGoal);
    }, [props.selectedGoal]);

    // Data fetching and state handling functions
    async function getGoalsForFilter() {
        axios
            .get(api.getFilterGoals, config)
            .then((response) => {
                setGoals(response.data)
            })
            .catch((error) => {
                return error.response.status
            })
    }


    async function getCoursesForFilter(goalId) {
        axios
            .get(api.getCourseExplorerCatalogCourses + goalId, config)
            .then((response) => {
                setCourses(response.data)
            })
            .catch((error) => {
                return error.response.status
            })
    }

    function handleGoalSelection(goalId) {
        props.handleGoalSelection(goalId)
        props.handleCourseSelection('')
        //getCoursesForFilter(goalId)
    }

    function handleCourseSelection(courseId) {
        props.handleCourseSelection(courseId)
    }

    return (
        <Stack direction={"row"} spacing={3}>
            {goalSelector}
            {courseSelector}
        </Stack>
    )
}